<template>
    <div class="auth-pass">
        <div class="form-group">
            <field-password v-model:value="value" 
                :placeholder="trans('auth.password')" 
                :classes="classes('input')"
                :validate-minlength="0" 
                :validate-strength="false">
                <template v-slot:prepend>
                    <span class="input-group-text" :class="classes('input')"><app-icon value="lock"></app-icon></span>
                </template>
            </field-password>
        </div>
        <div class="form-group">
            <a href="javascript:void(0);" class="pfp-engagement-link" @click="$emit('update:section', 'forgot')">
                {{trans('buttons.forgot')}}
            </a>
        </div>
    </div>
</template>

<script>
    import store from '../../store'
    import Password from '../../../components/Password'
    
	export default {
        emits:['update:password', 'update:section'],
        props: {
            password: { type: String, required: true },
            section : { type: String, required: true },
        },
        computed: {
            value: {
                get()  { return this.password             },
                set(v) { this.$emit('update:password', v) }
            }
        },
        mounted() {
            this.$emit('update:password', '')
            this.$nextTick(() => {
                let input = this.$el.querySelector('input[type="password"]')
                if (input) {
                    input.focus()
                }
            })
        },
        methods: {
            classes(index) { 
                return store.getters['classes'](index) 
            },
            trans(key) {
                let trans = store.getters.trans(key)
                return trans ? trans : this.$t('front.' + key)
            }
        },
        components: {
            'field-password': Password
        }
	}
</script>
